export enum HandbookLanguage {
    English = 1,
    Vietnamese = 2,
    Indonesian = 3,
}

export enum HowAreYouGoingToUse {
    TeachingClassroom = 1,
    TeachingAtHome = 2,
    Personal = 3,
    Other = 4,
}
